<template>
  <v-card outlined>
    <v-card-text>
      <v-layout row wrap align-center justify-space-between fill-height>
        <v-flex xs12 sm3>
          <v-text-field @focus="$event.target.select()" label="Category" v-model="category" outlined dense hide-details
            autocomplete ref="itemName"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field @focus="$event.target.select()" label="Item Name" ref="itemName" v-model="name" outlined dense
            hide-details autocomplete></v-text-field>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field class="right-input" ref="unitPrice" @focus="$event.target.select()" label="Amount"
            v-model="amount" outlined type="number" dense hide-details></v-text-field>
        </v-flex>

        <v-flex d-flex xs12 sm1>
          <v-btn color="info" ref="addbutton" large @click="submit">
            add
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      error: [],
      productSearchLoading: false,
      Products: [],
      phoneSearch: null,
      selectedProduct: null,
      category: null,
      name: null,
      amount: 0,
    };
  },
  methods: {
    emptyEntryBar() {
      this.name = null;
      // this.category = null;
      this.amount = 0;
      setTimeout(() => {
        this.$refs.itemName.focus();
      }, 300);
    },
    submit() {
      let campaignDetail = {
        category: this.category,
        name: this.name,
        amount: this.amount,
      };
      this.$emit("submit", campaignDetail);
      this.emptyEntryBar()
    },
  },
};
</script>

<style scoped></style>
